import { render } from "./CommunityPolicy.vue?vue&type=template&id=d764b50e"
import script from "./CommunityPolicy.vue?vue&type=script&lang=js"
export * from "./CommunityPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__